// app/src/services/Professionals/ProfessionalsService.js

import api from '../api';
import { addJWT } from '../JWTLegacyService';
import { addNonceToData } from '../NonceService';


//dataWithJWT = appels legacy avec un token garantissant l'identité de l'utilisateur
//dataWithNonce = appels classiques avec un token nonce empêchant le spam de nos apis
const PartsService = {

	partCompanyCreate: async (data, config = {}) => {
		const dataWithNonce = await addNonceToData(data);
		return api.post(`/partCompanyCreate`, dataWithNonce, config);
	},
	partContactCreate: async (data, config = {}) => {
		const dataWithNonce = await addNonceToData(data);
		return api.post(`/partContactCreate`, dataWithNonce, config)
	},
	partCustomerCreate: async (data, config = {}) => {
		const dataWithNonce = await addNonceToData(data);
		return api.post(`/partCustomerCreate`, dataWithNonce, config);
	},
	// --- [LEGACY MIGRATION] Demande de reset password pour les users legacy ---
	passwordReset: async (email, config = {}) => {
		const dataWithNonce = await addNonceToData({ email });
		return api.post(`/passwordReset`, dataWithNonce, config);
	},
};

export default PartsService;
